import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAddArticleRevenue } from '../models/add-article-revenue.model';
import { IArticleRevenue } from '../models/article-revenue.model';
import { IArticle } from '../models/article.model';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';

const BASE_URL: string = 'article';

@Injectable({
    providedIn: 'root',
})
export class ArticleResource {

    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getArticles(): Observable<IArticle[]> {
        return this.myCostAccountingRequestService.get<IArticle[]>(BASE_URL);
    }

    public getArticleRevenues(articleId: number): Observable<IArticleRevenue[]> {
        return this.myCostAccountingRequestService.get<IArticleRevenue[]>(`${BASE_URL}/${articleId}/revenue`);
    }

    public addArticleRevenues(articleId: number, revenue: IAddArticleRevenue): Observable<IArticleRevenue> {
        return this.myCostAccountingRequestService.post(`${BASE_URL}/${articleId}/revenue`, revenue);
    }

    public deleteArticleRevenue(articleId: number, revenueId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${articleId}/revenue/${revenueId}`);
    }
}
